import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/data/content";

const NAV = [
  { to: "/", label: "Accueil", end: true },
  { to: "/a-propos", label: "À propos" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#0ea5e9] text-white shadow-[0_4px_20px_rgba(14,165,233,0.25)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="logo-link" className="flex items-center">
            <span className="bg-white rounded-xl px-3 py-1.5 flex items-center shadow-sm">
              <img src={COMPANY.logo} alt="Equinoxe Propreté" className="h-12 w-auto" />
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s|à/g, "")}`}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                    isActive ? "bg-white/20" : "hover:bg-white/10"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={`tel:${COMPANY.phoneRaw}`}
              data-testid="header-phone"
              className="flex items-center gap-2 text-sm font-semibold"
            >
              <Phone size={16} /> {COMPANY.phone}
            </a>
            <Link
              to="/contact"
              data-testid="header-quote-btn"
              className="bg-white text-[#0284c7] hover:bg-sky-50 px-5 py-2.5 rounded-full text-sm font-bold transition-colors duration-200"
            >
              Devis gratuit
            </Link>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0284c7] px-6 pb-6 pt-2 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              onClick={() => setOpen(false)}
              className="block px-4 py-3 rounded-lg text-sm font-medium hover:bg-white/10"
            >
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            className="block text-center bg-white text-[#0284c7] px-5 py-3 rounded-full text-sm font-bold mt-3"
          >
            Devis gratuit
          </Link>
        </div>
      )}
    </header>
  );
};
